import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.css'],
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatSnackBarModule
  ]
})
export class ImageModalComponent {
  currentIndex: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string, allImages: string[] },
    public dialogRef: MatDialogRef<ImageModalComponent>,
    private snackBar: MatSnackBar
  ) {
    this.currentIndex = data.allImages.indexOf(data.imageUrl);
  }

  close(): void {
    this.dialogRef.close();
  }

  previousImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.data.imageUrl = this.data.allImages[this.currentIndex];
    }
  }

  nextImage(): void {
    if (this.currentIndex < this.data.allImages.length - 1) {
      this.currentIndex++;
      this.data.imageUrl = this.data.allImages[this.currentIndex];
    }
  }

  async onDownloadImage(url: string): Promise<void> {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      
      // Extraire le nom du fichier de l'URL ou utiliser un nom par défaut
      const urlParts = url.split('/');
      const fileName = urlParts[urlParts.length - 1].split('?')[0] || 'image.jpg';
      
      // Créer un objet URL pour le blob
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Créer un élément a invisible
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = blobUrl;
      link.download = fileName;
      
      // Ajouter à la page, cliquer, et nettoyer
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Libérer l'URL du blob
      window.URL.revokeObjectURL(blobUrl);
      
      this.snackBar.open('Image téléchargée avec succès', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    } catch (error) {
      console.error('Erreur lors du téléchargement de l\'image:', error);
      this.snackBar.open('Erreur lors du téléchargement de l\'image', 'Fermer', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    }
  }
}
